module.exports = __webpack_public_path__ + "img/technology-people-rot.487a144b.svg";